export default "__VITE_ASSET__ddiU5Ora__"